/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Directive, Input, Output, ElementRef, HostListener, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

function scrollSpyTo(id: string, selector: string = ScrollSpyContentDirective.defaultSelector, offset: number = -64) {
  const target = document.querySelector(`#${id}${selector}`);
  target?.scrollIntoView();
  if ((offset ?? 0) !== 0) {
    let scrollable = getScrollableElement(target as HTMLElement) as any;
    scrollable = (scrollable?.scrollingElement ?? scrollable) as HTMLElement;
    scrollable?.scrollBy(0, offset);
  }
}

export function getScrollableElement(element: HTMLElement): HTMLElement | Document {
  const excludeStaticParent = getComputedStyle(element).position === "absolute";

  const overflowRegex = /(auto|scroll)/;
  const isScrollable = function(el: HTMLElement): boolean {
    const style = getComputedStyle(el);
    if (el.offsetHeight >= el.scrollHeight) return false;
    if (excludeStaticParent && style.position === "static") return false;
    if (overflowRegex.test(style.overflow + style.overflowY + style.overflowX)) return true;
  }

  for (let parent = element; (parent = parent.parentElement);) {
    if (isScrollable(parent)) return parent;
  }
  
  return document;
}

@Directive({
  selector: '[scrollSpyContent]',
  exportAs: 'scrollSpyContent',
  standalone: false
})
export class ScrollSpyContentDirective implements OnInit {
  public static readonly defaultSelector: string = '.scrollspy';

  private _selector: string;
  get selector(): string { return this._selector; }
  @Input() set selector(value: string) {
    this._selector = value;
  }

  @Output() public sectionChange = new BehaviorSubject<string>(null);
  @Input() public reset = new BehaviorSubject<string>(null);
  private currentSectionId: string;
  private scrollable: any;
  private lastHeight: number;

  constructor(private readonly _el: ElementRef) { 
    if (!this.selector) this.selector = ScrollSpyContentDirective.defaultSelector;
  }

  ngOnInit(): void {
    this.reset?.subscribe(_ => this.resetScrollable());
    this.resetScrollable();
  }

  public scrollTo(itemId: string) {
    scrollSpyTo(itemId);
  }

  private resetScrollable() {
    const el = this._el.nativeElement as HTMLElement
    const currentHeight = el.offsetHeight;
    if (currentHeight !== this.lastHeight) {
      this.lastHeight = currentHeight;
      const last = this.scrollable as Element;
      const scrollable = getScrollableElement(el);
      if (scrollable) {
        last?.removeEventListener('scroll', this.scrollHandler, false);
        this.scrollable = scrollable;
        scrollable.addEventListener('scroll', this.scrollHandler, false);
      }
    }

    this.scrollHandler(this.scrollable);
  }

  private readonly scrollHandler = (e: any) => {
    let newSectionId: string;
    let maybeId: string;
    const htmlEl = this._el.nativeElement as HTMLElement;
    let target = e?.target ?? this.scrollable;
    target = target?.scrollingElement ?? target;
    if (!target) return;
    const scrollTop = target.offsetTop
    const scrollHeight = target.offsetHeight
    const scrollBottom = scrollTop + scrollHeight;

    const children = htmlEl.querySelectorAll(this.selector);
    children.forEach(child => {
      if (newSectionId) return;
      const element = child as HTMLElement;
      const rect = element.getBoundingClientRect();
      if (rect.top >= scrollTop) {
        maybeId = element.id;
      }
      if ((rect.bottom <= scrollBottom || rect.bottom > scrollHeight) && element.id === maybeId) {
        newSectionId = element.id;
      }
    });
    newSectionId = newSectionId ?? maybeId;
    if (!newSectionId) newSectionId = children[0]?.id;
    if (newSectionId !== this.currentSectionId) {
      this.currentSectionId = newSectionId;
      this.sectionChange.next(this.currentSectionId);
    }
  }
}

@Directive({
  selector: '[scrollSpyMenu]',
  exportAs: 'scrollSpyMenu',
  standalone: false
})
export class ScrollSpyMenuDirective implements OnInit {
  @Input() public sectionChange: BehaviorSubject<string>;

  constructor(private readonly _el: ElementRef) { }

  ngOnInit(): void {
    this.sectionChange?.subscribe(id => this.onSectionChange(id));
  }

  public onSectionChange(sectionId: string) {
    const menu = this._el.nativeElement as HTMLElement;
    const items = menu.querySelectorAll(`[scrollspymenuitem='']`);
    items?.forEach(item => {
      item.classList.remove('active');
      if (item.id === sectionId) item.classList.add('active');
    })
  }

}

@Directive({
  selector: '[scrollSpyMenuItem]',
  standalone: false
})
export class ScrollSpyMenuItemDirective {
  constructor(private readonly _el: ElementRef) { }

  @HostListener('click') onNavClick() {
    scrollSpyTo(this._el.nativeElement.id);
  }
}
